import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import styled from 'styled-components'

const acceptedStyleProps = [
  'fontFamily',
  'fontSize',
  'fontWeight',
  'lineHeight',
  'color',
  'textTransform',
]

const BaseStyledType = styled.div`
  ${props => {
    return Object.keys(props)
      .map(key => {
        if (!acceptedStyleProps.includes(key)) return ''

        return `${key
          .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2')
          .toLowerCase()}: ${props[key]};`
      })
      .join('')
  }}

  small {
    font-size: 70%;
  }
`

const TypeWithContext = ({ children, type, ...props }) => {
  const {
    typography: { styles: typography },
  } = useContext(ThemeContext)

  const { tag, ...mergedProps } = {
    ...typography[type],
    ...props,
  }

  const Type = BaseStyledType.withComponent(tag)

  return <Type {...mergedProps}>{children}</Type>
}

export const Canon = ({ children, ...props }) => (
  <TypeWithContext type={'Canon'} {...props}>
    {children}
  </TypeWithContext>
)

export const Trafalgar = ({ children, ...props }) => (
  <TypeWithContext type="Trafalgar" {...props}>
    {children}
  </TypeWithContext>
)

export const Paragon = ({ children, ...props }) => (
  <TypeWithContext type="Paragon" {...props}>
    {children}
  </TypeWithContext>
)

export const DoublePica = ({ children, ...props }) => (
  <TypeWithContext type="DoublePica" {...props}>
    {children}
  </TypeWithContext>
)

export const GreatPrimer = ({ children, ...props }) => (
  <TypeWithContext type="GreatPrimer" {...props}>
    {children}
  </TypeWithContext>
)

export const BodyCopy = ({ children, ...props }) => (
  <TypeWithContext type="BodyCopy" {...props}>
    {children}
  </TypeWithContext>
)

export const Brevier = ({ children, ...props }) => (
  <TypeWithContext type="Brevier" {...props}>
    {children}
  </TypeWithContext>
)
